export interface CronJobsBaseFrequency {
    none: number;
    minute: number;
    hour: number;
    day: number;
    week: number;
    month: number;
    year: number;
}
export interface CronJobsConfig {
    quartz?: boolean;
    multiple?: boolean;
    bootstrap?: boolean;
    option?: Record<string, boolean>; 
}
export interface CronJobsFrequency {
    baseFrequency: number;
    minutes: Array<number>;
    hours: Array<number>;
    daysOfMonth: Array<number>;
    daysOfWeek: Array<number>;
    months: Array<number>;
    nthMinutes: Array<number>;
}
export interface CronJobsSelectOption {
    value: number;
    type?: OptionType;
    label: string | number;
}
export enum OptionType {
    minute = 0,
    hour = 1,
    day = 2,
    week = 3,
    month = 4,
    year = 5
}
export interface CronJobsValidationConfig {
    validate?: boolean;
}
